'use client';

import { useBreakpoint } from '@/shared/hooks/use-media-query';
import { cn } from '@/shared/lib/cn';

interface AccountPageContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Wrapper component for account sub-pages
 * - On mobile: full background, constrained width (max-w-[720px])
 * - On desktop: no background/constraints (layout provides them)
 */
export function AccountPageContainer({
  children,
  className,
}: AccountPageContainerProps) {
  const { isLg } = useBreakpoint();

  // One element tree for both widths, only the classes differ: the breakpoint
  // resolves after hydration, and swapping trees remounted every account page
  // once, so one-shot state read on mount (the sign-in methods' merge message)
  // was taken by the first copy and lost.
  return (
    <div className={cn(!isLg && 'bg-muted/40', className)}>
      <div className={cn(!isLg && 'max-w-[720px] mx-auto')}>{children}</div>
    </div>
  );
}
